import React from 'react'
import { get } from 'lodash'
import { useTranslation } from 'react-i18next'
import useCurrentUser from 'lib/hooks/useCurrentUser'

import ErrorMessageContent from './ErrorMessageContent'
import Button from 'components/UI/Button'
import AuthLogic from 'components/Auth/AuthLogic'

const ViewForbidden403 = () => {
    const currentUser = useCurrentUser()
    const { t } = useTranslation('errors')

    return (
        <ErrorMessageContent
            title={t('errors:network.403.view.title')}
            content={t('errors:network.403.view.description', { fullName: get(currentUser, 'me.fullName', '???') })}
            actions={(
                <AuthLogic>
                    {({ logout, loading, currentLocation }) => (
                        <Button
                            trackName="signOut"
                            className="button button--medium"
                            onClick={() => logout(currentLocation)}
                            loading={loading}
                        >
                            {t('errors:network.403.view.switchUser')}
                        </Button>
                    )}
                </AuthLogic>
            )}
        />
    )
}

export default ViewForbidden403
